const FileOperators = {
    is_available: {
        id: 'is_available',
        matcher: (value, matchValue) => {
            return checkValueExistence(value);
        }
    },
    is_not_available: {
        id: 'is_not_available',
        matcher: (value, matchValue) => {
            return !(checkValueExistence(value));
        }
    }
}
module.exports.FileOperators = FileOperators;